import { render, staticRenderFns } from "./DeliveryPeisong.vue?vue&type=template&id=e0d2aff2&scoped=true&"
import script from "./DeliveryPeisong.vue?vue&type=script&lang=js&"
export * from "./DeliveryPeisong.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryPeisong.vue?vue&type=style&index=0&id=e0d2aff2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d2aff2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0d2aff2')) {
      api.createRecord('e0d2aff2', component.options)
    } else {
      api.reload('e0d2aff2', component.options)
    }
    module.hot.accept("./DeliveryPeisong.vue?vue&type=template&id=e0d2aff2&scoped=true&", function () {
      api.rerender('e0d2aff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/delivery/components/DeliveryPeisong.vue"
export default component.exports